import React from 'react';

const AddIcon = (props) => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='iconography/zoom-controls/plus-32x32' fill='currentColor'>
          <path d='M16,8 C16.5522847,8 17,8.44771525 17,9 L17,14.999 L23,15 C23.5522847,15 24,15.4477153 24,16 C24,16.5522847 23.5522847,17 23,17 L17,17 L17,23 C17,23.5522847 16.5522847,24 16,24 C15.4477153,24 15,23.5522847 15,23 L15,17 L9,17 C8.44771525,17 8,16.5522847 8,16 C8,15.4477153 8.44771525,15 9,15 L15,15 L15,9 C15,8.44771525 15.4477153,8 16,8 Z' />
        </g>
      </g>
    </svg>
  );
};

export default AddIcon;
